// extracted by css-extract-rspack-plugin
export default {"cls1":"step_two-cls1_CUM","cls2":"step_two-cls2_BKL step_two-cls1_CUM"};